import React, { memo } from 'react'
import { Feature, useFeatureFlag } from '@src/components/FeatureFlag'
// eslint-disable-next-line max-len
import { VideoCallsSteloUpsellPersistentPopup } from '@src/screens/Home/components/Banners/VideoCallsSteloUpsellPersistentPopup'
import { ByosDelaySyncInfo } from './ByosDelaySyncInfo'
import { DexcomDataSyncPopup } from './DexcomDataSyncPopup'
import { ExpiringSensorPopup } from './ExpiringSensorPopup'
import { MissingDexcomIntegrationPopup } from './MissingDexcomIntegrationPopup'
import { SensorStatusPopup } from './SensorStatusPopup'
import { SteloSetupPopup } from './SteloSetupPopup'
import { LabResultAnalysisCompletePopup } from './LabResultAnalysisCompletePopup'

export const InformationPopups = memo(() => {
  const isNotificationInboxEnabled = useFeatureFlag(Feature.NotificationInbox)

  return (
    <>
      <LabResultAnalysisCompletePopup />
      {!isNotificationInboxEnabled && <SteloSetupPopup />}
      {!isNotificationInboxEnabled && <MissingDexcomIntegrationPopup />}
      {!isNotificationInboxEnabled && <DexcomDataSyncPopup />}
      <ByosDelaySyncInfo />
      {!isNotificationInboxEnabled && <SensorStatusPopup />}
      {!isNotificationInboxEnabled && <ExpiringSensorPopup />}
      <VideoCallsSteloUpsellPersistentPopup />
    </>
  )
})
